import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_map",
  "use": "icon-project_map-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_map\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><path d=\"M18.581 6.98A1 1 0 0018 7.89v17.056a1 1 0 001.4.916l6-2.618a1 1 0 00.6-.917V5.124a1 1 0 00-1.419-.908l-6 2.764zM2.581 6.98A1 1 0 002 7.89v17.056a1 1 0 001.4.916l6-2.618a1 1 0 00.6-.917V5.124a1 1 0 00-1.419-.908l-6 2.764z\" /><path stroke-linecap=\"round\" d=\"M9 4l9 3M10 23l9 3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol